import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import {
  useOpenSelectIntegrationServiceModal,
  useOpenTriggersTemplatesModal
} from '../../../utils/routes/modals/modalsActions'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'

const Header = () => {
  const { entities, integrationsOnly } = useModalData() || {}
  const openNewTriggerModal = useOpenTriggersTemplatesModal()
  const openNewIntegrationModal = useOpenSelectIntegrationServiceModal()
  const onAddNew = integrationsOnly ? openNewIntegrationModal : openNewTriggerModal
  const context = integrationsOnly ? 'integration' : 'trigger'

  const canCreateTriggers = useSessionPermission('createTrigger')
  const { t } = useTranslation('triggers')
  const icon = integrationsOnly ? 'RiPlugLine' : 'RiRobotLine'

  return (
    <Grid gap={0.6} align="center">
      <Col>
        <Icon name={icon} color="dark3" size={1.4} />
      </Col>
      <Col>
        <Title size="h4" noMargin>
          {t('title', { context })}
        </Title>
      </Col>

      <Col flex={1} />

      {canCreateTriggers && (
        <Col>
          <Link onClick={() => onAddNew({ entities })}>
            <IconText
              label={t('new', { context })}
              size="small"
              iconSize="1rem"
              iconName="BsFillPlusCircleFill"
              color={COLORS.purple}
              noWrap
            />
          </Link>
        </Col>
      )}
    </Grid>
  )
}

export default Header
